import Color from '../Color.js';

Color.prototype.clipped = function () {
    return this._rgb._clipped || false;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/chroma-js/src/ops/clipped.js
// module id = 2521
// module chunks = 6